import { render } from "./EmpresaForm.vue?vue&type=template&id=3d8fc4d8&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=3d8fc4d8&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=3d8fc4d8&scoped=true&lang=css"
import "./EmpresaForm.vue?vue&type=style&index=2&id=3d8fc4d8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8fc4d8"]])

export default __exports__